import axios from "axios";

export const api = axios.create({
  baseURL: window.endPointApi,
  // baseURL: "https://uat-pharmax-api.atlasicloud.com/"
});
